import { render } from "./Versions.vue?vue&type=template&id=3d22d13d&scoped=true"
import script from "./Versions.vue?vue&type=script&lang=js"
export * from "./Versions.vue?vue&type=script&lang=js"

import "./Versions.vue?vue&type=style&index=0&id=3d22d13d&scoped=true&lang=css"

import exportComponent from "C:\\projects\\dcc\\site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d22d13d"]])

export default __exports__